import React, { useState } from "react";
import { Box } from "@mui/material";
import {
  People as PeopleIcon,
  Groups as GroupsIcon,
  Healing as HealingIcon,
  Chat as ChatIcon,
} from "@mui/icons-material";
import { useClinicTheme } from "../../theme";
import useAuth from "../../hooks/useAuth";
import TabbedPageShell from "../../components/organisms/TabbedPageShell";

import StaffTab from "../Clinics/ClinicDetail/StaffTab";
import StaffPerformanceTab from "./StaffPerformanceTab";
import TreatmentMetricsTab from "./TreatmentMetricsTab";
import useTerms from "../../hooks/useTerms";
import { useClinicModule } from "../../hooks/useClinicModule";
import CommunicationTab from "./CommunicationTab";

// İlk sekme varsayılandır — TabbedPageShell `?tab=` yoksa tabs[0]'ı açar.
const TABS = [
  { key: "personel-roller", label: "Personel ve Roller", icon: <GroupsIcon sx={{ fontSize: 18 }} /> },
  { key: "calisanlar", label: "Çalışan Performansı", icon: <PeopleIcon sx={{ fontSize: 18 }} /> },
  { key: "tedaviler", label: "Tedavi Metrikleri", icon: <HealingIcon sx={{ fontSize: 18 }} /> },
  { key: "iletisim", label: "Hasta İletişimi", icon: <ChatIcon sx={{ fontSize: 18 }} /> },
];

export default function BusinessPerformance() {
  const { auth } = useAuth();
  const token = auth?.accessToken;
  const { palette } = useClinicTheme();

  const terms = useTerms();
  const treatmentModule = useClinicModule("treatment");
  // Tedavi modülü kapalıysa (ör. diyetisyen) tedavi metrikleri sekmesi yok.
  const tabs = TABS.filter((t) => treatmentModule || t.key !== "tedaviler").map((t) =>
    t.key === "iletisim" ? { ...t, label: `${terms.patient} İletişimi` } : t
  );

  // Dönem seçimi performans sekmeleri arasında paylaşılır.
  const [period, setPeriod] = useState("this_month");

  return (
    <TabbedPageShell
      icon={<GroupsIcon sx={{ fontSize: 24 }} />}
      title="Personel"
      subtitle="Klinik personeli, rolleri ve performans metrikleri"
      tabs={tabs}
    >
      {(activeTab) => (
        <Box sx={{ flex: 1, overflow: "auto", minHeight: 0, display: "flex", flexDirection: "column" }}>
          {activeTab === "personel-roller" && (
            <StaffTab
              apiMode="clinic"
              clinic={auth?.clinic || null}
              clinicId={auth?.clinic?._id || auth?.user?.clinic?._id || auth?.clinic}
              token={token}
              palette={palette}
            />
          )}
          {activeTab === "calisanlar" && (
            <StaffPerformanceTab token={token} period={period} onPeriodChange={setPeriod} />
          )}
          {activeTab === "tedaviler" && (
            <TreatmentMetricsTab token={token} period={period} onPeriodChange={setPeriod} />
          )}
          {activeTab === "iletisim" && (
            <CommunicationTab token={token} period={period} onPeriodChange={setPeriod} />
          )}
        </Box>
      )}
    </TabbedPageShell>
  );
}
